import { createApiClient, handleError, handleResponse } from '@/helpers/api'
import store from '../store'

const apiCmsClient = createApiClient(`${window.config.VUE_APP_CMS_API_BASE_URL}`)

// EXPORTS
export const cmsService = {
  fetchContent,
  filterCMSContent,
  get,
  getContent,
  fetchErrorContent,
  letterTemplate
}

// API CALLS
function letterTemplate() {
  return apiCmsClient
    .get('/stationery', {
      responseType: 'arraybuffer'
    })
    .then(handleResponse)
    .catch(handleError)
}

// fetches content from the cms-middleware
async function fetchContent(form) {
  // async trigger for error fetch
  return Promise.reject(form)
  // store.dispatch('loadErrors')
  // return apiCmsClient
  //   .get(form)
  //   .then(response => {
  //     let result = response.data[0] ? response.data[0] : response.data
  //     return result
  //   })
  //   .catch(handleError)
}

async function fetchErrorContent(form) {
  return Promise.reject(form)
  // return apiCmsClient
  //   .get(form)
  //   .then(response => {
  //     let result = response.data[0] ? response.data[0] : response.data
  //     return result
  //   })
  //   .catch(handleError)
}

function get(array, filterValue, replaceValues = {}) {
  let cmsContent = this.filterCMSContent(array, filterValue);

  // Ensure cmsContent is a string
  if (typeof cmsContent !== 'string') {
    cmsContent = String(cmsContent);
  }

  // Replace placeholder with replacement-value
  for (const [key, value] of Object.entries(replaceValues)) {
    cmsContent = cmsContent.replace(key, value);
  }
  return cmsContent;
}

function getContent(array, filterValue) {
  return this.filterCMSContent(array, filterValue)
}

function filterCMSContent(array, filterValue) {
  array = array.data || array
  const filtered = array.filter(
    content =>
      content.name === filterValue &&
      content.language ===
        (store.getters.locale ? store.getters.locale.toUpperCase() : 'DE')
  )
  if (filtered.length !== 0) {
    // return content if found
    const firstIndex = filtered[0]
    return firstIndex === undefined ? '' : firstIndex.content
  } else {
    // return error if in develop-stage
    // return empty string if production-stage
    return process.env.NODE_ENV === 'development'
      ? Error(
          `Key '${filterValue}' for lang: '${
            store.getters.locale ? store.getters.locale.toUpperCase() : 'DE'
          }' not found in CMS or JSON`
        )
      : ''
  }
}
